import { render, staticRenderFns } from "./CreatePackage.vue?vue&type=template&id=674f412a"
import script from "./CreatePackage.vue?vue&type=script&lang=ts"
export * from "./CreatePackage.vue?vue&type=script&lang=ts"
import style0 from "./CreatePackage.vue?vue&type=style&index=0&id=674f412a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports